import { TranslateService } from '@ngx-translate/core';

import { IStateSliceDefaults, StateSliceName } from '../store.models';
import { Sport } from '../sport/sport.models';

import { IGameStateModel } from './game.models';

export const gameStateDefaults: IStateSliceDefaults<IGameStateModel> = Object.freeze({
    sliceName: StateSliceName.GAME,
    defaults: {
        gameId: undefined,
        game: undefined,
        periods: null,
        vidParams: undefined,
        scores: null,
        selectedPeriod: undefined
    }
});

const DEFAULT_EXTRA_TIME_SPORT = Sport.HOCKEY;

/**
 * Returns the appropriate label for the period based on the regulation time periods.
 *
 * @param period
 * @param regulationPeriods
 * @param sport
 * @param translate
 */
export const getPeriodLabel = (
    period: number | null | undefined,
    regulationPeriods: number,
    sport: Sport | undefined,
    translate: TranslateService
): string | undefined => {
    if (!period) {
        return;
    }

    if (period <= regulationPeriods) {
        return `${period}`;
    }

    const labelKey = `SPORT.ADDITIONAL_TIME_ABBREVIATIONS.${(sport ?? DEFAULT_EXTRA_TIME_SPORT).toUpperCase()}`;
    return `${translate.instant(labelKey)}${period - regulationPeriods}`;
};
